module.exports = "<p class=q-marg-all-sm> This order has {%- numberOfLpns %} more LPN(s). Please scan the next LPN. </p>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/amazon/html/lpnsToScanMessage.html
// module id = 280
// module chunks = 1